var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentAlt = function SvgCommentAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H3C1.345 0 0 1.345 0 3v13.5c0 1.655 1.345 3 3 3h4.5v3.938a.56.56 0 0 0 .895.45L14.25 19.5H21c1.655 0 3-1.345 3-3V3c0-1.655-1.345-3-3-3m.75 16.5c0 .413-.337.75-.75.75h-7.5l-.6.45-3.15 2.363V17.25H3a.75.75 0 0 1-.75-.75V3c0-.413.337-.75.75-.75h18c.413 0 .75.337.75.75z"
  })));
};
export default SvgCommentAlt;